import { render } from "./CriarUsuarioPlanilha.vue?vue&type=template&id=95cedf44&scoped=true"
import script from "./CriarUsuarioPlanilha.vue?vue&type=script&lang=js"
export * from "./CriarUsuarioPlanilha.vue?vue&type=script&lang=js"

import "./CriarUsuarioPlanilha.vue?vue&type=style&index=0&id=95cedf44&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cedf44"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QFile,QBtn});
